var _rect, _circle, _g, _circle2, _g2, _circle3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionCardBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 574,
    viewBox: "0 0 1020 574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1584_92672)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 574,
    rx: 12
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1584_92672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 739,
    y: 286,
    width: 562,
    height: 562
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1020,
    cy: 567,
    r: 280,
    fill: "#26B6E0",
    stroke: "#26B6E0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1584_92672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1019.61 8L1579.61 568",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1012.54 15.0703L1572.54 575.07",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.47 22.1426L1565.47 582.143",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.401 29.2129L1558.4 589.213",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.33 36.2852L1551.33 596.285",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.259 43.3555L1544.26 603.355",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.188 50.4258L1537.19 610.426",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.117 57.498L1530.12 617.498",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.046 64.5684L1523.05 624.568",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.975 71.6387L1515.97 631.639",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.903 78.7109L1508.9 638.711",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.833 85.7812L1501.83 645.781",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.762 92.8535L1494.76 652.854",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.69 99.9238L1487.69 659.924",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.619 106.994L1480.62 666.994",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.549 114.066L1473.55 674.066",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.478 121.137L1466.48 681.137",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.406 128.207L1459.41 688.207",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.335 135.279L1452.33 695.279",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.264 142.35L1445.26 702.35",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.193 149.422L1438.19 709.422",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.122 156.492L1431.12 716.492",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.051 163.562L1424.05 723.563",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.979 170.635L1416.98 730.635",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.909 177.705L1409.91 737.705",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.838 184.777L1402.84 744.777",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.767 191.848L1395.77 751.848",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.695 198.918L1388.7 758.918",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.624 205.99L1381.62 765.99",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.554 213.061L1374.55 773.061",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.482 220.133L1367.48 780.133",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.411 227.203L1360.41 787.203",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.34 234.273L1353.34 794.273",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.27 241.346L1346.27 801.346",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.198 248.416L1339.2 808.416",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.127 255.488L1332.13 815.488",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.056 262.559L1325.06 822.559",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.984 269.629L1317.98 829.629",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.914 276.701L1310.91 836.701",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.843 283.771L1303.84 843.771",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.771 290.842L1296.77 850.842",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.7 297.914L1289.7 857.914",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.63 304.984L1282.63 864.984",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.559 312.057L1275.56 872.057",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.487 319.127L1268.49 879.127",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.416 326.197L1261.42 886.197",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.346 333.27L1254.35 893.27",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.274 340.34L1247.27 900.34",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.203 347.41L1240.2 907.41",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.132 354.482L1233.13 914.482",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.061 361.553L1226.06 921.553",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.99 368.625L1218.99 928.625",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.919 375.695L1211.92 935.695",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.848 382.766L1204.85 942.766",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.776 389.838L1197.78 949.838",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.706 396.908L1190.71 956.908",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.635 403.98L1183.63 963.98",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.563 411.051L1176.56 971.051",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.492 418.121L1169.49 978.121",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.421 425.193L1162.42 985.193",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.351 432.264L1155.35 992.264",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.279 439.336L1148.28 999.336",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.208 446.406L1141.21 1006.41",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.137 453.477L1134.14 1013.48",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.066 460.549L1127.07 1020.55",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.995 467.619L1120 1027.62",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.924 474.691L1112.92 1034.69",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.853 481.762L1105.85 1041.76",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.782 488.832L1098.78 1048.83",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.711 495.904L1091.71 1055.9",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.64 502.975L1084.64 1062.97",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.568 510.045L1077.57 1070.04",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.497 517.117L1070.5 1077.12",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.427 524.188L1063.43 1084.19",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.355 531.26L1056.36 1091.26",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.284 538.33L1049.28 1098.33",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.213 545.4L1042.21 1105.4",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.143 552.473L1035.14 1112.47",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.071 559.543L1028.07 1119.54",
    stroke: "#26B6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461 566.613L1021 1126.61",
    stroke: "#26B6E0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1584_92672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -51,
    y: -51,
    width: 362,
    height: 362
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 130,
    r: 180,
    fill: "#F54F5E",
    stroke: "#F54F5E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1584_92672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.554 -226L486.554 134",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.482 -218.93L479.482 141.07",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.411 -211.857L472.411 148.143",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34 -204.787L465.34 155.213",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2695 -197.715L458.27 162.285",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1982 -190.645L451.198 169.355",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.127 -183.574L444.127 176.426",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0557 -176.502L437.056 183.498",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9844 -169.432L429.984 190.568",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9141 -162.361L422.914 197.639",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8428 -155.289L415.843 204.711",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7715 -148.219L408.771 211.781",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7002 -141.146L401.7 218.854",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6299 -134.076L394.63 225.924",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5586 -127.006L387.559 232.994",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4873 -119.934L380.487 240.066",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.416 -112.863L373.416 247.137",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3457 -105.791L366.346 254.209",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.725586 -98.7207L359.274 261.279",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.79688 -91.6504L352.203 268.35",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.8682 -84.5781L345.132 275.422",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.9395 -77.5078L338.061 282.492",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.0098 -70.4375L330.99 289.563",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36.0811 -63.3652L323.919 296.635",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.1523 -56.2949L316.848 303.705",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.2236 -49.2227L309.776 310.777",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.2939 -42.1523L302.706 317.848",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.3652 -35.082L295.635 324.918",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.4365 -28.0098L288.563 331.99",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78.5078 -20.9395L281.492 339.061",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.5791 -13.8672L274.421 346.133",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-92.6494 -6.79688L267.351 353.203",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-99.7207 0.273438L260.279 360.273",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-106.792 7.3457L253.208 367.346",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.863 14.416L246.137 374.416",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.934 21.4883L239.066 381.488",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128.005 28.5586L231.995 388.559",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-135.076 35.6289L224.924 395.629",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-142.147 42.7012L217.853 402.701",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-149.218 49.7715L210.782 409.771",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-156.289 56.8418L203.711 416.842",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-163.36 63.9141L196.64 423.914",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-170.432 70.9844L189.568 430.984",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-177.503 78.0566L182.497 438.057",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-184.573 85.127L175.427 445.127",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-191.645 92.1973L168.355 452.197",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.716 99.2695L161.284 459.27",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205.787 106.34L154.213 466.34",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-212.857 113.412L147.143 473.412",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-219.929 120.482L140.071 480.482",
    stroke: "#F54F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-227 127.553L133 487.553",
    stroke: "#F54F5E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1584_92672",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 360,
    width: 560,
    height: 560
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 640,
    r: 280,
    fill: "#196DB6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1584_92672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.614 81L839.614 641",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.543 88.0703L832.543 648.07",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.473 95.1426L825.473 655.143",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.401 102.213L818.401 662.213",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.33 109.285L811.33 669.285",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.259 116.355L804.259 676.355",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.188 123.426L797.188 683.426",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.117 130.498L790.117 690.498",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.046 137.568L783.046 697.568",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.975 144.639L775.975 704.639",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.903 151.711L768.903 711.711",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.833 158.781L761.833 718.781",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.762 165.854L754.762 725.854",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.69 172.924L747.69 732.924",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.619 179.994L740.619 739.994",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.549 187.066L733.549 747.066",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.478 194.137L726.478 754.137",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.406 201.207L719.406 761.207",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.335 208.279L712.335 768.279",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.264 215.35L705.264 775.35",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.193 222.422L698.193 782.422",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.122 229.492L691.122 789.492",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.051 236.562L684.051 796.563",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.979 243.635L676.979 803.635",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.909 250.705L669.909 810.705",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.838 257.777L662.838 817.777",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7666 264.848L655.767 824.848",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6953 271.918L648.695 831.918",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.624 278.99L641.624 838.99",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5537 286.061L634.554 846.061",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4824 293.133L627.482 853.133",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4111 300.203L620.411 860.203",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3398 307.273L613.34 867.273",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2695 314.346L606.27 874.346",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1982 321.416L599.198 881.416",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.127 328.488L592.127 888.488",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0557 335.559L585.056 895.559",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9844 342.629L577.984 902.629",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9141 349.701L570.914 909.701",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84277 356.771L563.843 916.771",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.22852 363.842L556.771 923.842",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10.2998 370.914L549.7 930.914",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-17.3701 377.984L542.63 937.984",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.4414 385.057L535.559 945.057",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.5127 392.127L528.487 952.127",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.584 399.197L521.416 959.197",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.6543 406.27L514.346 966.27",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52.7256 413.34L507.274 973.34",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.7969 420.41L500.203 980.41",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-66.8682 427.482L493.132 987.482",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73.9395 434.553L486.061 994.553",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-81.0098 441.625L478.99 1001.63",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88.0811 448.695L471.919 1008.7",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.1523 455.766L464.848 1015.77",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-102.224 462.838L457.776 1022.84",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.294 469.908L450.706 1029.91",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.365 476.98L443.635 1036.98",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-123.437 484.051L436.563 1044.05",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-130.508 491.121L429.492 1051.12",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-137.579 498.193L422.421 1058.19",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.649 505.264L415.351 1065.26",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-151.721 512.336L408.279 1072.34",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-158.792 519.406L401.208 1079.41",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-165.863 526.477L394.137 1086.48",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-172.934 533.549L387.066 1093.55",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-180.005 540.619L379.995 1100.62",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-187.076 547.691L372.924 1107.69",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-194.147 554.762L365.853 1114.76",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-201.218 561.832L358.782 1121.83",
    stroke: "#196DB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-208.289 568.904L351.711 1128.9",
    stroke: "#196DB6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_92672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1020,
    height: 574,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCardBackground);
export default __webpack_public_path__ + "static/media/questionCardBackground.7819f5946709b317c287f0b88c8df5ef.svg";
export { ForwardRef as ReactComponent };